export enum SiteSectionSlug {
	Passengers = '',
	Business = 'business',
	Careers = 'careers',
	OXD = 'oxd-airport',
	CvgElevate = 'cvg-elevate',
}

export const siteSectionSlugValues = new Set(Object.values(SiteSectionSlug));
